import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article';
  /** Anchor for the coach-mark tour spotlight (issue #57). */
  'data-tour'?: string;
}

export function Card({ children, className = '', as: Tag = 'div', 'data-tour': dataTour }: CardProps) {
  return (
    <Tag
      data-tour={dataTour}
      className={`rounded-[var(--radius-card)] bg-surface p-4 shadow-[var(--shadow-card)] ${className}`}
    >
      {children}
    </Tag>
  );
}

export function CardTitle({ children }: { children: ReactNode }) {
  return <h2 className="text-[17px] font-semibold text-content">{children}</h2>;
}
